import { render, staticRenderFns } from "./UserPhoneBindModal__Style#Drawer.vue?vue&type=template&id=039d0a5e&scoped=true&"
import script from "./UserPhoneBindModal__Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./UserPhoneBindModal__Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./UserPhoneBindModal__Style#Drawer.vue?vue&type=style&index=0&id=039d0a5e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039d0a5e",
  null
  
)

export default component.exports